 import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from '@angular/core';
import { BarInputs, ChartComponent, ChartType } from '@charts';
import { ChartCardComponent } from '../../chart-card/chart-card.component';
import { TransformerPhasesLegend } from '../../../../models/infraestructure.models';
import { TransformerLegendComponent } from '../../transformer-phases-legend/transformer-phases-legend.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { ChartHeader } from '@charts';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ChartCardComponent,
    ChartComponent,
    TransformerLegendComponent,
    TranslocoDirective,
    ChartHeader,
  ],
  selector: 'ui-rsabt-voltage-phases-chart',
  template: `
    <ng-container *transloco="let t">
      <ui-chart-card>
        <div class="flex flex-col justify-between h-full w-full">
          <chart-header
            [title]="t('CHARTS.VOLTAGE.TITLE')"
            [subtitle]="
              t('CHARTS.VOLTAGE.SUBTITLE') + ' = ' + voltageReference() + 'V'
            "
          />
          <chart [type]="chartType()" [typeInputs]="inputs()" />
          <ui-transformer-phases-legend
            [legend]="transformerPhasesLegend()"
          />
        </div>
      </ui-chart-card>
    </ng-container>
  `,
})
export class RsabtVoltagePhasesChartComponent {
  inputs = input.required<BarInputs>();
  transformerPhasesLegend = input.required<TransformerPhasesLegend[]>();

  voltageReference = computed(
    () => this.inputs().annotations.lineReference.yMin,
  );

  chartType = signal<ChartType>('bar');
}
